<template>
  <div class="reason-sars-mention-gold p-3">
    <h4>Why SARs were filed mentioning gold companies</h4>
    <p class="mb-0">The reasons banks gave for filing a suspicious activity report that mentioned gold companies in the FinCEN Files leak.</p>
    <stacked-bar-chart :data="data" label-above hide-legend :social-mode="socialMode" :fixed-height="height" />
    <p class="text-muted mt-2 small text-right">Source: FinCEN Files</p>
    <p class="mt-2 font-italic">This data is not representative of all SARs received by the U.S. Department of Treasury's Financial Crimes Enforcement Network.</p>
  </div>
</template>

<script>
import chart from '../mixins/chart'

export default {
  name: 'ReasonsSarsMentionGold',
  mixins: [chart],
  data () {
    return {
      data: [
        { label: 'Money laundering', value: 54 },
        { label: 'Financial instrument or payment mechanism', value: 35 },
        { label: 'Other suspicious activities', value: 26 },
        { label: 'Affected financial soundness', value: 11 },
        { label: 'Bonding company notified', value: 10 }
      ]
    }
  }
}
</script>
